import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import styled from 'styled-components/macro';

const Select = props => {
  const { disabled, ...rest } = props;
  return (
    <SelectContainer>
      <ReactSelect isDisabled={disabled} {...rest} styles={getStyles(props)} />
    </SelectContainer>
  );
};

Select.defaultProps = {
  size: 'medium',
  disabled: false,
};

Select.propTypes = {
  /**
   * Array of option objects
   */
  options: PropTypes.array.isRequired,

  /**
   * The selected option object
   */
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /**
   * One of "small" or "medium" (default)
   */
  size: PropTypes.string,

  /**
   * Disabled (default false)
   */
  disabled: PropTypes.bool,

  /**
   * Placeholder text (default undefined)
   */
  placeholder: PropTypes.string,

  /**
   * Change handler
   */
  onChange: PropTypes.func,

  /**
   * Width
   */
  width: PropTypes.number,

  /**
   * Min width
   */
  minWidth: PropTypes.number,
};

export default Select;

const SelectContainer = styled.div`
  #certiself-form & {
    margin-bottom: 24px;
  }
`;

const getStyles = ({
  size,
  isClearable,
  showAllOptions,
  isMulti,
  width,
  minWidth,
  fontSize,
  zIndex,
  disableMultiselectRemove,
}) => {
  const valueContainer = {
    padding: '0 8px',
  };

  if (isMulti) {
    valueContainer.padding = '4px 8px';
    valueContainer.display = 'flex';
    valueContainer.flexWrap = 'wrap';
    valueContainer.flex = 1;
    valueContainer.overflowX = 'hidden';
  }

  return {
    control: (base, state) => ({
      ...base,
      width: width ? width : '100%',
      minWidth: minWidth ? minWidth : '',
      background: state.isDisabled ? '#efefef' : 'white',
      outline: 'none',
      fontSize: fontSize ? fontSize : '15px',
      minHeight: size === 'small' ? '32px' : '38px',
      borderColor: '#ccc',
      '&:hover': {
        borderColor: '#ccc',
      },
      boxShadow: 'none',
      padding: '12px',
    }),
    valueContainer: base => ({ ...base, ...valueContainer }),
    placeholder: base => ({
      ...base,
      color: '#b4b4b4',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: base => ({
      ...base,
      color: '#666666',
      padding: '0 8px',
    }),
    menuPortal: base => ({
      ...base,
      zIndex: zIndex ? zIndex : 1,
    }),
    menu: base => ({
      ...base,
      width: width ? width : '100%',
      minHeight: showAllOptions ? 'fit-content' : base.minHeight,
      margin: 0,
    }),
    menuList: base => ({
      ...base,
      minHeight: showAllOptions ? 'fit-content' : base.minHeight,
      overflowX: 'hidden',
    }),
    option: (base, state) => ({
      ...base,
      background: state.isSelected
        ? '#552a55'
        : state.isFocused
        ? '#f3f0f3'
        : state.isActive
        ? 'red'
        : null,
      color: state.isSelected ? 'white' : state.isFocused ? '#484848' : null,
      whiteSpace: 'nowrap',
      overflowX: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: fontSize ? fontSize : base.fontSize,
      ':active': {
        backgroundColor: '#552A55',
        color: 'white',
      },
    }),
    singleValue: base => ({
      ...base,
      maxWidth: isClearable ? 'calc(100% - 72px)' : 'calc(100% - 36px)',
    }),
    multiValue: base => ({
      ...base,
      paddingRight: disableMultiselectRemove ? '3px' : '',
    }),
    multiValueRemove: base => ({
      ...base,
      display: disableMultiselectRemove ? 'none' : 'flex',
    }),
  };
};
